// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__qg2-+","slider":"Switch_slider__8tjUH","round":"Switch_round__oVc+U"};